module.exports = __webpack_public_path__ + "static/media/brush.86cb09c7.png";